/* eslint-disable no-param-reassign */
import 'core-js/stable';
import ResizeObserver from 'resize-observer-polyfill';
import { polyfillCryptoRandomUUID } from '~/utils/cryptoPolyfill';

// # scrollTo patch catches unsupported scrollTo args in legacy browsers
// # crypto.randomUUID polyfill for browsers that don't support it
((global) => {
  if (!global.ResizeObserver) {
    global.ResizeObserver = ResizeObserver;
  }
  global.scrollToOriginal = global.scrollTo;
  global.scrollTo = (...args) => {
    try {
      global.scrollToOriginal.apply(window, args);
    } catch (err) {
      console.warn(`[POPMENU] Window.scrollTo failed: ${err.toString()}`);
    }
  };

  // Apply crypto.randomUUID polyfill
  polyfillCryptoRandomUUID(global);
})(typeof window === 'undefined' ? this : window);
console.log('[POPMENU] Polyfill Initialized (scrollTo, crypto.randomUUID)');
